module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-7c064af910c55dbba6a59395b9c6f795.png";